'use client';

import React, { Fragment } from 'react';
import Global from "../../styles/global-styles.mjs";

/**
 * GlobalStyles contains a small number of important but unopinionated global style rules.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-globalstyles--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/GlobalStyles)
 */
export var GlobalStyles = function GlobalStyles() {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Global, null));
};